import React from "react";
import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    background: #fff;
    padding-top: 1em;
    text-align: center
`;

const StyledButton = styled.button`
    background: ${props => props.checked ? '#fff' : '#fff'};
    color: ${props => props.checked ? '#787878' : '#787878'};
    border: ${props => props.checked ? '1px solid #369cf7' : '1px solid #fff'};
    font-size: 14px;
    padding: .8rem;
    font-family: 'RobotoBold', sans-serif;
    font-weight: bold;
    border-radius: 4px;
    text-align: center;
    margin: 7px;
    width: 90%;
    box-shadow: 0 3px 8px #969696
    &:hover {
        cursor: pointer;
        background: #fff;
        color: #787878;
        outline:none;
        border: 1px solid #369cf7;
    }
`;

const ButtonMB = styled.button`
    background-color: #254aa5;
    border: none;
    color: white;
    padding: 8px 4px;
    font-size: 7px;
    font-weight: bold;
    border-radius: 50%;
    position: relative;
    margin: -40% -27% 0% 0%;
    float: right;
  `;


const ContainerDetailMB = styled.div`
    background: #fff;
    border: none;
    border-radius: 5px;
    width: 59%;
    padding: 4% 2%;
    margin: 0% 0% -16% 6%;
    text-align: center;
    font-size: 12px;
    box-shadow: 0 2px 12px #ccc
    position: relative;
    z-index: auto;
    display: ${props => props.detailMbVisible? "block": "none" };
    animation: fadeinout 4s linear 1 forwards;
    @keyframes fadeinout {
        0% { opacity: 0; }
        20% { opacity: 1; }
        80% { opacity: 1; }
        100% { opacity: 0; }
    }
`;

class ChipInputClaroSocio extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            fields:[],
            detailMbVisible : false,
            mb: 0,
            buttonState:{
                disabled:true
            },
        }
    }

    componentDidMount() {
        setInterval(function() {
            this.setState({detailMbVisible: false})
        }.bind(this), 5000);
    }

    handleOnClick = (e, mb, hasPromotion, inputType, cost, idExternal) => {
        if(hasPromotion){
            this.setState({detailMbVisible: true, mb:mb})
        }
        this.props.handleInputClick(e, inputType, [], cost, idExternal)
    }

    render(){

        if(this.props.planInformationQuery){
            return(
                <Container>
                    <ContainerDetailMB detailMbVisible={this.state.detailMbVisible}>
                        Obtén <span style={{color:"blue", fontWeight:"bold"}}>{this.state.mb} Megas</span> de regalo
                    </ContainerDetailMB>
                    
                    { 
                        this.props.plans.detail.map((item, key) => {
                            { 
                                const check = (item.idExternal == this.props.selectedItemId)?true:false
                                let toolTipLbl = (item.hasPromotion)?item.promotion.toolTipLbl:"";

                                return <>
                                    <div style={{
                                        "display": "inline-Block",
                                        "width": "30%"
                                    }}>
                                        <StyledButton  checked={check}
                                            onClick= {(e) => this.handleOnClick(
                                                e, 
                                                toolTipLbl, 
                                                item.hasPromotion,
                                                this.props.input.type, 
                                                item.cost, 
                                                item.idExternal
                                            )}
                                        > 
                                            {"$"+ item.cost} 
                                            {(item.hasPromotion)?<ButtonMB onClick={ (e) => this.handleOnClick(e, toolTipLbl, item.hasPromotion )}>{item.promotion.badgeLbl}</ButtonMB>:<></>}
            
                                        </StyledButton>
                                    </div>
                                </>
                            }
            
                        })
                    }
                </Container>
            )
        } else{
            return(
                <Container>
                    { 
                        this.props.input.field.itemsList.map((item, key) => {
                            const check = (item.productID == this.props.selectedItemId)?true:false
                            return <div style={{
                                "display": "inline-Block",
                                "width": "31%"
                            }}>
                                <StyledButton  
                                    checked={check}
                                    onClick= {(e) => this.props.handleInputClick(e, this.props.input.type, [], item.amount, item.productID)}
                                > 
                                    {item.label} 
                                </StyledButton>
                            </div>
                        })
                    }
                </Container>
            )
        }
        
    }
}

export default ChipInputClaroSocio;